/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://7rngveh5dvcjznwj2utuafnv6i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-muems7wfg5g75k6hpj22tbbjee",
    "aws_cloud_logic_custom": [
        {
            "name": "lrexsiterest",
            "endpoint": "https://o3qpv9l9o5.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:9515aa2c-ea7d-4c54-9b3f-b0870990cb05",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_tXmsNO1RD",
    "aws_user_pools_web_client_id": "33tkcouuams3a1qlu3dhrqvaki",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "lrexsite-bucket132452-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
